export enum DashboardType {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND'
}
